import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductService from '../Services/ProductService.js';
import Header from '../Components/Heading.js';
import EditProduct from '../Components/EditProduct.js';

export default function UpdateProduct(props) {
	const [ searchParams, setSearchParams ] = useSearchParams();
	const [ product, setProduct ] = useState(null);
	useEffect(() => {
		const url = decodeURI(searchParams.get('url'));
		const slug = url.split('/products/').pop();
		const domain = url.replace('https://', '').replace('http://', '').replace('www.', '').split('/products/')[0];
		console.log(slug);
		console.log(domain);
		ProductService.getProduct(domain, slug).then((a) => {
			console.log(a);
			setProduct(a);
		});
	}, []);
	return (
		<div className="grid justify-items-center">
			{product && <EditProduct existingValues={product} type="UPDATE" />}
		</div>
	);
}
